import React, { useState } from 'react';
const { nativeIdentityCredential } = require('../utils/nativeIdentity');
export default function NativeIdentityButton({ provider, onCredential, label }) {
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const name = provider === 'google' ? 'Google' : 'Facebook';
  async function login() {
    if (busy) return; setBusy(true); setError('');
    try { const credential = await nativeIdentityCredential(provider); await onCredential(credential); }
    catch (_) { setError(`${name} girişi tamamlanmadı. Tekrar deneyebilirsin.`); }
    finally { setBusy(false); }
  }
  return <div><button type="button" disabled={busy} onClick={login} className="min-h-12 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 font-bold text-slate-800 disabled:opacity-50">{busy ? 'Bağlanıyor…' : (label || `${name} ile devam et`)}</button>{error && <p role="alert" className="mt-2 text-xs text-red-700">{error}</p>}</div>;
}
